import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/Team/Get', params)
    },
    getList: params => {
        return API.GET('/api/Team/List', params)
    },
    select: params => {
        return API.GET('/api/Team/select', params)
    },
    add: params => {
        return API.POST('/api/Team/Add', params)
    },
    adminAdd:params=>{
        return API.POST('/api/Team/AdminAdd',params)
    },
    edit: params => {
        return API.POST('/api/Team/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/Team/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Team/DeleteBatch', params)
    },
    register: params => {
        return API.POST('/api/Team/Register', params)
    },
    search:params=>{
        return API.GET('/api/team/Search',params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/team.js